import styled from 'styled-components';

export const Leader = styled.p`
    color: white;
    font-size: 1rem;
    text-align: center;
`;
